import { Grid2, Typography } from "@mui/material";
import StatusBox from "../../../components/StatusBox";
import { useTranslate } from "../../../hooks/useTranslate";
import SummaryBox from "../../../components/SummaryBox";
import RecommendedSubjects from "./components/RecommendedSubjects";
import useStatuses from "../../../context/status/useStatuses";
import LockedPage from "../../../components/LockedPage";
import VerificationStatusChip from "../../../components/VerificationStatusChip";

const CourseSelection = () => {
    const { t } = useTranslate();
    const {
        isLockedStatus: { courseSelection: isLocked }, statuses, refetchGeneralStatuses, generalStatuses,
    } = useStatuses();
    const isLockedForKus = generalStatuses.school === "KUS" && generalStatuses.student.studySchedule === "Full Time";

    return (
        <div className="page-content">
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Typography variant="h1">
                        {t("courseSelection.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4" component="div">
                        {t("courseSelection.description")}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5, lg: 4 }}>
                    <StatusBox
                        title={t("courseSelection.courseSelectionStatus")}
                        isSuccess={statuses.courseSelection.isSuccess}
                        isWarning={statuses.courseSelection.isWarning}
                        isInfo={statuses.courseSelection.isInfo}
                    >
                        <Typography variant="body2">
                            {t("courseSelection.courseSelectionStatusDescription")}
                        </Typography>
                        <VerificationStatusChip status={statuses.courseSelection} />
                    </StatusBox>
                </Grid2>
            </Grid2>
            <LockedPage isLocked={isLocked || isLockedForKus}>
                <SummaryBox className="mt-12 mb-12" isFormBox>
                    <RecommendedSubjects
                        onComplete={refetchGeneralStatuses}
                        isCompleted={statuses.courseSelection.isSuccess}
                    />
                </SummaryBox>
            </LockedPage>
        </div>
    );
};

export default CourseSelection;
